import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import moment from 'moment';
import { CreditAppDataRow } from './types';

export interface ColumnHeader {
  key: string;
  label: string;
}

// MM-DD-YYYY stamp for export file names (dashes since "/" is a path separator).
const getExportDateStamp = () => moment().format('MM-DD-YYYY');

const formatRowForExport = (
  row: CreditAppDataRow,
  columns: ColumnHeader[]
): Record<string, string | number> => {
  const formatted: Record<string, string | number> = {};
  columns.forEach((header) => {
    const value = row[header.key as keyof CreditAppDataRow];
    if (typeof value === 'number' && !isNaN(value)) {
      // Keep the actual number, including negatives (credits) and zero.
      formatted[header.label] = value;
    } else if (typeof value === 'string') {
      formatted[header.label] = value;
    } else {
      formatted[header.label] = '';
    }
  });
  return formatted;
};

export const exportToXlsx = (rows: CreditAppDataRow[], columns: ColumnHeader[]) => {
  const formattedRows = rows.map((r) => formatRowForExport(r, columns));
  const worksheet = XLSX.utils.json_to_sheet(formattedRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Credit Applications Report');
  XLSX.writeFile(workbook, `credit-applications-report-${getExportDateStamp()}.xlsx`);
};

export const exportToCsv = (rows: CreditAppDataRow[], columns: ColumnHeader[]) => {
  const formattedRows = rows.map((r) => formatRowForExport(r, columns));
  const csv = Papa.unparse(formattedRows, { columns: columns.map((c) => c.label) });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `credit-applications-report-${getExportDateStamp()}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
